export enum ThemeId {
    LIGHT = 'light',
    DARK = 'dark',
}
